import { axiosInstance, API_PREFIX } from '@/shared/api';
import type { ApiResponse } from '@/shared/api';
import type { PermissionResponse } from '../model/types';

export const permissionApi = {
  getPermissions: async (): Promise<ApiResponse<PermissionResponse>> => {
    const { data } = await axiosInstance.get<ApiResponse<PermissionResponse>>(
      `${API_PREFIX.ADMIN_V1}/auth/user-permissions`
    );
    return data;
  },
};
